import * as React from 'react';

const SvgIcon = (props) => {
  if (props.size == 'xsm') {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill={props.fill || '#1D252D'} viewBox="0 -960 960 960">
        <path d="m620.92-316.92 37.16-37.16L506-506.16V-720h-52v236.15zM480.07-116q-75.21 0-141.4-28.42-66.18-28.42-115.99-78.21t-78.25-116.09Q116-405.01 116-480.39t28.42-141.75 78.21-115.68 116.09-77.75Q405.01-844 480.39-844t141.75 28.66q66.38 28.66 115.48 77.79T815.36-622 844-480.07q0 75.21-28.42 141.4-28.42 66.18-77.71 115.99t-115.76 78.25Q555.64-116 480.07-116m.41-52q129.47 0 220.5-91.5Q792-351 792-480.48q0-129.47-91.02-220.5Q609.95-792 480.48-792 351-792 259.5-700.98 168-609.95 168-480.48 168-351 259.5-259.5T480.48-168"></path>
      </svg>
    );
  }

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill={props.fill || '#1D252D'} viewBox="0 -960 960 960">
      <path d="m618.92-298.92 42.16-42.16L510-492.16V-680h-60v212.15zM480.07-100q-78.84 0-148.21-29.92t-120.68-81.21-81.25-120.63Q100-401.1 100-479.93q0-78.84 29.92-148.21t81.21-120.68 120.63-81.25Q401.1-860 479.93-860q78.84 0 148.21 29.92t120.68 81.21 81.25 120.63Q860-558.9 860-480.07q0 78.84-29.92 148.21t-81.21 120.68-120.63 81.25Q558.9-100 480.07-100m-.07-60q133 0 226.5-93.5T800-480t-93.5-226.5T480-800t-226.5 93.5T160-480t93.5 226.5T480-160"></path>
    </svg>
  );
};

export default React.memo(SvgIcon);
